import { CMS } from "../components/cms/cms";
import { A  } from "@solidjs/router";
import { SectionHeader } from "../components/section-header";
import { Progress } from "../components/progress";

export function Payment() {
    return (
        <>
            <SectionHeader>
                <h1>
                    <CMS id="atelier-application/introduction::page-title">Payment method</CMS>
                </h1>
                <p>
                    <a href="/"><CMS text id="nav::home">Home</CMS></a> / <A href="/introduction"><CMS text id="nav::atelier-application">ARC Atelier Application</CMS></A>
                </p>
            </SectionHeader>
            <div style="text-align: center;">
                <Progress step={6} />
                <h2 class="m-t-xxl" style="font-size: 3em; font-family: 'Oswald';">
                    Your application is now ready to be submitted
                </h2>
                <div class="row" style="font-size: 2em; margin: 60px 0;">
                    <div class="col-md-6">
                        <p>
                            <span style="color: red;">USD <b>$250</b></span> application fee
                        </p>
                    </div>
                </div>
                <p style="font-size: 1.5em; margin-top: 40px;">
                    Please choose between <b>credit card</b> or <b>Paypal</b> as the desired form of payment to submit your school's application.
                </p>
                <div style="margin-top: 40px;">
                    <div style="display: inline-block;">
                        <A href={"/payment/credit-card"}>
                            <img src="/Images/icons/credit-card-icon.png" style="height: 100px; width: auto;" />
                        </A>
                    </div>
                    <div style="display: inline-block; margin: 0 40px; top: 20px;">
                        <span style="font-family: 'Oswald'; font-size: 3em;">
                            OR
                        </span>
                    </div>
                    <div style="display: inline-block;">
                        <A href={"/payment/paypal"}>
                            <img src="/Images/icons/paypal-icon.png" style="height: 100px; width: auto;" />
                        </A>
                    </div>
                </div>
            </div>
        </>       
    );
}